module.exports = __webpack_public_path__ + "img/07.9eb13eb4.png";